'use client';

import React from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Drawer, Divider, useTheme, Typography } from '@mui/material';

import { useTranslate } from 'src/locales';

function CustomDrawer({ open, onClose, handleback, title, width, children, zeroPadding = false }) {
  const theme = useTheme();
  const { t } = useTranslate();
  const isRTL = theme.direction === 'rtl';
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      ModalProps={{ sx: { zIndex: 1550 } }}
      slotProps={{
        paper: {
          sx: {
            p: 1,
            width: { xs: '100%', md: width || 450 },
            zIndex: 1600, // Or higher than your sidebar
          },
        },
      }}
    >
      <Box sx={{ px: { xs: zeroPadding ? 0 : 2, md: 4 }, py: 3 }}>
        <Box display="flex" alignItems="center" gap={2}>
          <ArrowBackIcon
            onClick={handleback}
            sx={{ cursor: 'pointer', transform: isRTL ? 'rotate(180deg)' : 'none' }}
          />
          <Typography variant="h6" textAlign="center">
            {title}
          </Typography>
        </Box>
        <Divider style={{ borderStyle: 'dashed' }} sx={{ my: 2 }} />
        {children}
      </Box>
    </Drawer>
  );
}

export default CustomDrawer;
